
interface ComboFinalCtaProps {
  lang: 'en' | 'ja';
}

export default function ComboFinalCta({ lang }: ComboFinalCtaProps) {
  const handleWhatsApp = () => {
    const msg = lang === 'en'
      ? "Hi! I'd like to book the Tokyo Night Combo Experience (Izakaya + Karaoke). Could you share availability and details? Thank you!"
      : "こんにちは！Tokyo Night Combo Experience（居酒屋＋カラオケ）の予約に興味があります。空き状況と詳細を教えていただけますか？";
    window.open(`https://wa.me/819092895522?text=${encodeURIComponent(msg)}`, '_blank');
  };

  const t = {
    en: {
      title: 'Ready for the Best Night in Tokyo?',
      desc: 'Spots are limited. Book your Tokyo Night Combo Experience now and make your stay unforgettable.',
      cta: 'Book via WhatsApp',
      sub: 'Usually responds within a few hours',
      features: ['Max 4 guests', '4–5 hours', 'From ¥30,000'],
    },
    ja: {
      title: '東京最高の夜、準備はできていますか？',
      desc: '定員制です。今すぐTokyo Night Combo Experienceを予約して、忘れられない滞在にしましょう。',
      cta: 'WhatsAppで予約する',
      sub: '通常数時間以内に返信します',
      features: ['最大4名', '4〜5時間', '¥30,000〜'],
    },
  }[lang];

  return (
    <section id="final-cta" className="py-24 px-4 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f7d3da75d4d7c66966c34e00e069c907.jpg"
          alt="Tokyo Night"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/65 to-black/80"></div>
      </div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-white/10 border border-white/20 rounded-full mb-7">
          <i className="ri-beer-line text-amber-400 text-sm"></i>
          <i className="ri-add-line text-white/40 text-xs"></i>
          <i className="ri-mic-fill text-pink-400 text-sm"></i>
        </div>

        <h2 className="text-4xl md:text-5xl font-bold text-white mb-5 leading-tight">
          {t.title}
        </h2>
        <p className="text-gray-300 text-base md:text-lg mb-8 leading-relaxed">
          {t.desc}
        </p>

        {/* Features */}
        <div className="flex flex-wrap justify-center gap-4 mb-10">
          {t.features.map((f, i) => (
            <div key={i} className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
              <i className="ri-check-line text-amber-400 text-sm"></i>
              <span className="text-white text-sm font-medium">{f}</span>
            </div>
          ))}
        </div>

        <button
          onClick={handleWhatsApp}
          className="inline-flex items-center gap-3 px-12 py-5 bg-green-500 hover:bg-green-600 text-white text-xl font-bold rounded-full shadow-2xl hover:shadow-green-500/40 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer mb-4"
        >
          <i className="ri-whatsapp-line text-2xl"></i>
          {t.cta}
        </button>
        <p className="text-gray-400 text-sm">{t.sub}</p>
      </div>
    </section>
  );
}
